import template from './editRoleModal.html';
import controller from './editRoleModal.controller';

let EditRoleModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

export default EditRoleModalComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/editRoleModal/editRoleModal.component.js